import { ToggleCard } from '../ToggleCard';
export function RadioCard(props) {
    return <ToggleCard type="radio" {...props}/>;
}
